import { apiRequest } from './api';
import { TokenDelivery, TokenDeliveryRequest, TokenDeliveryUpdateRequest, Token } from '../types/tokenDelivery';

export const tokenDeliveryService = {
  // Get all token-delivery connections
  getAllTokenDeliveries: async (): Promise<TokenDelivery[]> => {
    return await apiRequest<TokenDelivery[]>('/token_deliveries');
  },

  // Get token-delivery connection by ID
  getTokenDeliveryById: async (id: number): Promise<TokenDelivery> => {
    return await apiRequest<TokenDelivery>(`/token_deliveries/${id}`);
  },

  // Create new token-delivery connection
  createTokenDelivery: async (request: TokenDeliveryRequest): Promise<TokenDelivery> => {
    return await apiRequest<TokenDelivery>('/token_deliveries/create', {
      method: 'POST',
      body: JSON.stringify(request)
    });
  },

  // Update existing token-delivery connection
  updateTokenDelivery: async (id: number, request: TokenDeliveryUpdateRequest): Promise<TokenDelivery> => {
    return await apiRequest<TokenDelivery>(`/token_deliveries/${id}`, {
      method: 'PUT',
      body: JSON.stringify(request)
    });
  },

  // Delete token-delivery connection
  deleteTokenDelivery: async (id: number): Promise<void> => {
    return await apiRequest<void>(`/token_deliveries/${id}`, {
      method: 'DELETE'
    });
  },

  // Get all tokens (for dropdown)
  getAllTokens: async (): Promise<Token[]> => {
    return await apiRequest<Token[]>('/tokens');
  }
};
